import React, { useRef } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsExclamationCircleFill } from "react-icons/bs";
import toast from "react-hot-toast";
import { Media } from "../../views/sites/addSite";
import ImageCard from "./ImageCard";

/**
 * @function CustomImgUpload
 * @description for CustomImgUpload
 * @returns JSX for CustomImgUpload
 */

const CustomImgUpload = ({
  media,
  handleAddMedia,
  handleDeleteMedia,
  handleDefaultMedia,
  retryHandler,
}) => {
  const hiddenFileInput = useRef(null);
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  function handleImageChange(event) {
    const selectedFiles = Array.from(event.target.files);
    let dataToSave = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      const isDefault = i === 0 && media.length === 0 ? true : false;
      dataToSave.push(
        new Media(
          selectedFiles[i].name + selectedFiles[i].type,
          selectedFiles[i],
          "",
          isDefault,
          {},
          "",
          selectedFiles[i].size > 5 * 1024 * 1024 ? true : false
        )
      );
    }
    handleAddMedia(dataToSave);
  }

  const handleDeletePhoto = (mediaToDelete) => {
    console.log("media to delete :", mediaToDelete);
    if (mediaToDelete.isDefault) {
      toast.error("Default file can't be deleted first remove default mark");
    } else handleDeleteMedia(mediaToDelete.id);
  };
  console.log("render Image Upload component");
  const imageCards = () => {
    return (
      <React.Fragment>
        {media?.length > 0 &&
          media.map((item, i) => (
            <ImageCard
              item={item}
              retryHandler={retryHandler}
              key={i}
              handleDeletePhoto={handleDeletePhoto}
              handleDefaultMedia={handleDefaultMedia}
            />
          ))}
      </React.Fragment>
    );
  };

  return (
    <div className="upload-img-main-container">
      <div className="img-guildlines">
        <span>
          <BsExclamationCircleFill />
        </span>
        <p className="img-guildlines-para">
          {
            "You are allowed to uploads files with the following formates : JPG/JPEG/PNG/WEBP/MP4/MOV/HEIC . The maximum image size is permitted is 5 MB maintain a consistent of 1:1 aspect ratio for images/videos."
          }
        </p>
      </div>
      <div className="upload-img-wrapper">
        <div className="box-decoration" onClick={handleClick} name={"images"}>
          <label
            htmlFor="image-upload-input"
            className="image-upload-label label-container"
          >
            <div className="m-0 p-0 d-flex flex-column justify-center align-items-center">
              <span className="label-icons">
                <BiImageAdd />
              </span>
              <span className="label-heading">
                {"Add Images "}
                <span className="label-star">*</span>
              </span>
            </div>
            <span className="lable-para">{"or drag and drop here"}</span>

            {/* {siteData.errors.images && siteData.touched.images ? (
              <div className=" image--upload--error--message">
                {siteData.errors.images}
              </div>
            ) : ( */}
            <span className="lable-warning">
              {
                "Check the image upload guidlines before uploading (Recommended)."
              }
            </span>
            {/* )} */}
          </label>
          <div>
            <input
              name="images"
              multiple
              type="file"
              onChange={handleImageChange}
              ref={hiddenFileInput}
              className="image-upload-input"
              accept="image/png, image/jpg, image/jpeg, image/webp , video/mp4" //
            />
          </div>
        </div>

        {imageCards()}
      </div>
    </div>
  );
};

export default React.memo(CustomImgUpload);
